<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('total_guest') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="px-6 my-5">
          <v-img v-if="isHotels" src="@/assets/custom/hotels/images/total_guest.webp" contain />
          <v-img v-else src="@/assets/images/svg/total_guest.svg" contain />
        </div>
        <div v-if="isHotels" class="text-center ma-auto descTextHotel">
          {{ $t('custom.hotel.max_delivered') }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="mt-5">
        <div class="">
          <div class="text-center">
            <h4 class="title font-weight-medium">
              {{ $t('total_guest') }}
            </h4>
          </div>
          <div class="d-flex align-center justify-center py-10">
            <v-btn color="primary" fab outlined small :disabled="disabled" @click="form.total_guest = form.total_guest - 1">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <h1 class="display-3 px-5 font-weight-medium">
              {{ form.total_guest }}
            </h1>
            <v-btn color="primary" fab outlined small @click="form.total_guest = form.total_guest + 1">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <div class="__menu-bottom menu-full">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
          <v-btn type="submit" color="primary" block x-large class="text-none" @click="selectMenu">
            {{ $t('select_menu') }}
          </v-btn>
        </v-col>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      disabled: true,
      form: {
        total_guest: 1,
        table: '',
        item: []
      }
    }
  },
  computed: {
    isHotels() {
      const url_hotel = this.$store.state.store_hotels
      const url_id = this.$store.state.url_domain
      if (url_hotel.indexOf(url_id) !== -1) {
        return true
      }
      return false
    }
  },
  watch: {
    'form.total_guest': function(newItem, oldItem) {
      if (newItem > 1) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    }
  },
  created() {
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN'))) this.form = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN'))
  },
  methods: {
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    },
    async selectMenu() {
      this.$store.dispatch('saveDataCartDineIn', this.form)
      this.$router.push({ name: 'dinein_menu' }).catch(() => {})
    }
  }
}
</script>
